module.exports = __webpack_public_path__ + "img/15.cfd9c43c.png";